<template>
  <div class="home-footer">
    <div class="services-container">
      <div class="service-container">
        <div class="main-title">服务与支持</div>
        <div class="sub-title service-btn" @click="handleHelpClick">使用帮助</div>
      </div>
      <div class="service-container">
        <div class="main-title">关于我们</div>
        <div class="sub-title service-btn" @click="handleCompanyIntroClick">公司简介</div>
        <div class="sub-title service-btn" @click="handleProductIntroClick">产品介绍</div>
        <div class="sub-title service-btn" @click="handleContactClick">联系我们</div>
      </div>
      <div class="service-container follow-me-container">
        <div class="main-title">关注我们</div>
        <div class="sub-titles">
          <div class="sub-title">
            <div class="sub-title-text">抖音</div>
            <img
              class="follow-code-img"
              src="@/assets/image/dy-code.png"
              alt="抖音二维码"
            >
          </div>
          <div class="sub-title">
            <div class="sub-title-text">小红书</div>
            <img
              class="follow-code-img"
              src="@/assets/image/xhs-code.png"
              alt="小红书二维码"
            >
          </div>
          <div class="sub-title">
            <div class="sub-title-text">微信公众号</div>
            <img
              class="follow-code-img"
              src="@/assets/image/gzh-code.png"
              alt="微信公众号二维码"
            >
          </div>
        </div>
      </div>
    </div>
    <div class="contact-container">
      <div class="kefu">联系客服</div>
      <div class="phone">
        经理陈萍：13795343747（微信同号）
      </div>
      <div class="phone">
        客服阿颜：15300439684（微信同号）
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeFooter',
  methods: {
    getBaseUrl() {
      // 生产环境需要拼接 /web 前缀
      const prefix = process.env.NODE_ENV === 'production' ? '/web' : '';
      return `${window.location.origin}${prefix}`;
    },
    handleCompanyIntroClick() {
      // 打开新窗口跳转到公司简介页面
      const url = `${this.getBaseUrl()}/companyIntroduction`;
      window.open(url, '_blank');
    },
    handleProductIntroClick() {
      // 打开新窗口跳转到产品介绍页面
      const url = `${this.getBaseUrl()}/ProductIntroduction`;
      window.open(url, '_blank');
    },
    handleContactClick() {
      // 打开新窗口跳转到联系我们页面
      const url = `${this.getBaseUrl()}/contactUs`;
      window.open(url, '_blank');
    },
    handleHelpClick() {
      // 打开新窗口跳转到使用帮助页面
      const url = `${this.getBaseUrl()}/help`;
      window.open(url, '_blank');
    },
  },
};
</script>

<style lang="less" scoped>
.home-footer {
  width: 1150px;
  min-height: 200px;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  margin: 104px auto 0;

  .services-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start; /* 主轴 start */
    align-items: flex-start;     /* 副轴 start */
    border-right: 1px solid #E1E1E1;

    .service-container {
      margin-right: 160px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start; /* 主轴 start */
      align-items: flex-start;     /* 副轴 start */

      .main-title {
        font-weight: 500;
        font-size: 20px;
        color: #FFFFFF;
        margin-bottom: 15px;
      }

      .sub-title {
        font-weight: 500;
        font-size: 15px;
        color: #E1E1E1;
        margin-bottom: 10px;

        &.service-btn {
          cursor: pointer;

          &:hover {
            color: #CA5EFB;
          }
        }
      }

      &.follow-me-container {
        margin-right: 80px;
        /* 预留：如需单独调整“关注我们”一列的 margin 或宽度，可在此处修改 */

        .sub-titles {
          display: flex;
          flex-direction: row;         /* sub-titles 横向排列 */
          flex-wrap: nowrap;           /* 不允许换行 */
          justify-content: flex-start; /* 主轴 start */
          align-items: center;         /* 副轴居中 */
          gap: 24px;

          .sub-title {
            display: flex;
            flex-direction: column;     /* sub-title 竖向排列：文字在上，二维码在下 */
            justify-content: flex-start;
            align-items: flex-start;
            gap: 12px;

            .sub-title-text {
              /* 保持与其他 sub-title 文本风格一致 */
            }

            .follow-code-img {
              width: 53px;
              height: 53px;
              object-fit: cover;
            }
          }
        }
      }
    }
  }

  .contact-container {
    display: flex;
    flex-direction: column;
    justify-content: flex-start; /* 主轴 start */
    align-items: flex-end;       /* 副轴 end */
    margin-left: auto;

    .kefu {
      width: 254px;
      height: 40px;
      margin-bottom: 30px;
      background: linear-gradient(90deg, #7149FF 0%, #CE5EFB 100%);
      box-shadow: inset 0px 4px 10px 0px rgba(255, 255, 255, 0.6);
      border-radius: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: 500;
      font-size: 18px;
      color: #FFFFFF;
    }

    .phone {
      margin-bottom: 18px;
      font-weight: 500;
      font-size: 15px;
      color: #FFFFFF;
    }
  }
}
</style>
